/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Token } from '../models';
/**
 * RegisterApi - axios parameter creator
 * @export
 */
export const RegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Service to finalize a register process
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endRegister: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('endRegister', 'token', token)
            const localVarPath = `/api/register/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Service to register a new user
         * @param {string} username The username used to be identified
         * @param {string} password The user password
         * @param {string} fullName The user password
         * @param {string} prefix The phone code area
         * @param {string} phone The user phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initRegister: async (username: string, password: string, fullName: string, prefix: string, phone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('initRegister', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('initRegister', 'password', password)
            // verify required parameter 'fullName' is not null or undefined
            assertParamExists('initRegister', 'fullName', fullName)
            // verify required parameter 'prefix' is not null or undefined
            assertParamExists('initRegister', 'prefix', prefix)
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('initRegister', 'phone', phone)
            const localVarPath = `/api/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (fullName !== undefined) {
                localVarQueryParameter['fullName'] = fullName;
            }

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Service to finalize a register process
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endRegister(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endRegister(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Service to register a new user
         * @param {string} username The username used to be identified
         * @param {string} password The user password
         * @param {string} fullName The user password
         * @param {string} prefix The phone code area
         * @param {string} phone The user phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initRegister(username: string, password: string, fullName: string, prefix: string, phone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initRegister(username, password, fullName, prefix, phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegisterApiFp(configuration)
    return {
        /**
         * 
         * @summary Service to finalize a register process
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endRegister(token: string, options?: any): AxiosPromise<Token> {
            return localVarFp.endRegister(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Service to register a new user
         * @param {string} username The username used to be identified
         * @param {string} password The user password
         * @param {string} fullName The user password
         * @param {string} prefix The phone code area
         * @param {string} phone The user phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initRegister(username: string, password: string, fullName: string, prefix: string, phone: string, options?: any): AxiosPromise<void> {
            return localVarFp.initRegister(username, password, fullName, prefix, phone, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI {
    /**
     * 
     * @summary Service to finalize a register process
     * @param {string} token The token received to finalize registration process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public endRegister(token: string, options?: AxiosRequestConfig) {
        return RegisterApiFp(this.configuration).endRegister(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Service to register a new user
     * @param {string} username The username used to be identified
     * @param {string} password The user password
     * @param {string} fullName The user password
     * @param {string} prefix The phone code area
     * @param {string} phone The user phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public initRegister(username: string, password: string, fullName: string, prefix: string, phone: string, options?: AxiosRequestConfig) {
        return RegisterApiFp(this.configuration).initRegister(username, password, fullName, prefix, phone, options).then((request) => request(this.axios, this.basePath));
    }
}
